<template>
  <div class="mx-4">
    <h1 class="text-white text-center text-lg font-bold p-4">ثبت سفارش</h1>
    <div class="rounded-xl p-4 bg-gray-900">
      <form action="" @submit.prevent="postOrder">
        <div class="flex gap-2">
          <Input type="tel" placeholder="شماره همراه" v-model="user.phonE_NUMBER" required/>
          <button class="rounded-xl bg-yellow-500 p-2" @click.prevent="checkCustomer">
            <SearchIcon class="h-6 w-6"/>
          </button>
        </div>

        <Input type="text" class="mt-4" placeholder="نام و نام خانوادگی" v-model="user.name" required/>

        <Input type="number" class="mt-4" placeholder="تعداد افراد" v-model="user.count" required/>

        <Input type="number" class="mt-4" placeholder="شماره میز" v-model="tableNumber" required/>

        <select class="mt-4 w-full rounded-xl p-2 bg-white text-black" v-model="selectedHall" required>
          <option value="" class="" disabled>انتخاب مکان</option>
          <option v-for="hall in ceremonyHalls"
                  :key="hall.shO_SALON"
                  :value="hall.shO_SALON"
                  class="text-black">{{ hall.namE_SALON }}
          </option>
        </select>

        <Button class="mt-4" type="submit">ادامه</Button>

        <div class="flex gap-4">
          <button class="w-full bg-blue-600 rounded-xl p-3 mt-4 text-white text-sm" @click.prevent="updateFactor()"
                  v-if="editFactor">
            ویرایش مکان
          </button>

          <!-- <button class="w-full bg-red-500 rounded-xl p-3 mt-4 text-white text-sm" @click.prevent="deleteFactor()"
                  v-if="editFactor">حذف فاکتور
          </button> -->
        </div>
      </form>
    </div>
  </div>

</template>

<script>
import {SearchIcon} from "@heroicons/vue/outline";
import Input from "@/components/Input";
import {deleteFactor, getCeremonyHalls, getCustomerInfo, updateFactorHeader} from "@/API/API";
import {mapGetters} from "vuex";
import Button from "@/components/General/Button";

export default {
  name: "SubmitOrder",
  components: {Button, Input, SearchIcon},
  data() {
    return {
      user: {
        phonE_NUMBER: this.$store.state.factor.sho_Mobile,
        name: this.$store.state.factor.taF_NAME,
        count: this.$store.state.factor.tedad
      },
      ceremonyHalls: [],
      selectedHall: this.$store.state.factor.saloonID,
      tableNumber: this.$store.state.factor.desK_NUMBER,
    }
  },
  computed: {
    ...mapGetters(['editFactor'])
  },
  async created() {
    this.ceremonyHalls = (await getCeremonyHalls()).data.result
  },
  methods: {
    async checkCustomer() {
      this.user.name = (await getCustomerInfo(this.user.phonE_NUMBER)).data.result.name
    },
    async postOrder() {
      const vm = this;
      const factor = {
        user: vm.user,
        location: vm.selectedLocation,
        hall: vm.selectedHall,
        tableNumber: vm.tableNumber
      }
      this.$store.dispatch('setInitialFactor', factor)
    },
    deleteFactor() {
      let factor = this.$store.state.factor
      this.$swal({
        icon: 'warning',
        title: 'حذف فاکتور',
        text: 'آیا از حذف فاکتور مطمئن هستید ؟',
        confirmButtonColor: '#EF4444',
        confirmButtonText: 'بلی',
        showCancelButton: true,
        cancelButtonColor: '#6B7280',
        cancelButtonText: 'لغو',
      }).then((result) => {
        if (result.isConfirmed) {
          deleteFactor(factor)
              .then(resp => {
                this.$store.dispatch('emptyCart')
                this.$swal({
                  icon: 'success',
                  title: 'موفق',
                  text: resp.data.message,
                  confirmButtonColor: '#fcd34d',
                  confirmButtonText: 'باشه'
                }).then(() => {
                  this.$store.dispatch('emptyCart')
                  this.$router.replace('/menu')
                })
                
              })
              .catch(err => {
                let unorderedList = document.createElement('ul')
                unorderedList.classList.add('text-sm', 'text-right', 'list-disc')

                err.response.data.result.forEach(error => {
                  let li = document.createElement('li')
                  li.innerText = error.col
                  unorderedList.appendChild(li)
                });

                this.$swal({
                  icon: 'error',
                  title: 'خطا',
                  html: unorderedList,
                  confirmButtonColor: '#fcd34d',
                  confirmButtonText: 'باشه'
                })
              })
        }
      })
    },
    updateFactor() {
      let factor = this.$store.state.factor
      factor.desK_NUMBER = this.tableNumber
      factor.saloonID = this.selectedHall
      this.$swal({
        icon: 'warning',
        title: 'ویرایش فاکتور',
        text: 'آیا از ویرایش شماره میز مطمئن هستید ؟',
        confirmButtonColor: '#10b981',
        confirmButtonText: 'بلی',
        showCancelButton: true,
        cancelButtonColor: '#6B7280',
        cancelButtonText: 'لغو',
      }).then((result) => {
        if (result.isConfirmed) {
          updateFactorHeader(factor)
              .then(resp => {
                this.$store.dispatch('emptyCart')
                this.$swal({
                  icon: 'success',
                  title: 'موفق',
                  text: resp.data.result,
                  confirmButtonColor: '#fcd34d',
                  confirmButtonText: 'باشه'
                }).then(() => {
                  this.$store.dispatch('emptyCart')
                  this.$router.replace('/menu')
                })
              })
              .catch(err => {
                this.$swal({
                  icon: 'error',
                  title: 'خطا',
                  text: err.response.data.message,
                  confirmButtonColor: '#fcd34d',
                  confirmButtonText: 'باشه'
                })
              })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>